export default "__VITE_ASSET__84njlrp3__"